import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a89cbc06"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons-round" }, "", -1))
const _hoisted_2 = { class: "camera skeleton" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "camera" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QrcodeStream = _resolveComponent("QrcodeStream")!
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component), {
    title: "Сканировать",
    description: "Для получения доступа наведите камеру на qr код.",
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.show) = $event))
  }, {
    icon: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: "material-icons-round",
          textContent: _toDisplayString(_ctx.camPermission && !_ctx.error ? '' : '')
        }, null, 8, _hoisted_3),
        _withDirectives(_createElementVNode("span", null, "Необходимо разрешение", 512), [
          [_vShow, !_ctx.camPermission]
        ]),
        _withDirectives(_createElementVNode("span", {
          textContent: _toDisplayString(_ctx.error)
        }, null, 8, _hoisted_4), [
          [_vShow, _ctx.error]
        ])
      ], 512), [
        [_vShow, !_ctx.showCam]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createVNode(_component_QrcodeStream, {
          onDecode: _ctx.onDecode,
          onInit: _ctx.onInit
        }, null, 8, ["onDecode", "onInit"])
      ], 512), [
        [_vShow, _ctx.showCam]
      ])
    ]),
    actions: _withCtx(() => [
      (_ctx.$device.isDesktop)
        ? (_openBlock(), _createBlock(_component_Btn, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = false)),
            label: "Отмена"
          }))
        : _createCommentVNode("", true),
      (!_ctx.camPermission)
        ? (_openBlock(), _createBlock(_component_Btn, {
            key: 1,
            label: "Разрешить",
            filled: "",
            onClick: _ctx.openManual
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}